import { ActionIcon } from '@vindr/ui';
import { TableColumnsType } from 'antd';
import { useTranslation } from 'react-i18next';

const useAccountColumns = ({ onRemove }): TableColumnsType<any> => {
  const { t } = useTranslation('Vindoc');

  return [
    {
      title: '#',
      width: 40,
      dataIndex: 'id',
      key: 'id',
      ellipsis: true,
      render: (_, __, index) => index + 1,
    },
    // {
    //   title: t('Status'),
    //   width: 100,
    //   dataIndex: 'status',
    //   key: 'status',
    //   ellipsis: true,
    //   sorter: sorter,
    //   render: (status) => ORDER_STATUS[status],
    // },
    {
      title: t('Full Name'),
      width: 110,
      dataIndex: 'fullname',
      key: 'fullname',
      ellipsis: true,
    },
    {
      title: t('Actions'),
      dataIndex: 'operation',
      key: 'operation',
      align: 'center',
      width: 80,
      fixed: 'right',
      render: (text, record) => {
        return (
          <ActionIcon>
            <ActionIcon.Delete onClick={() => onRemove(record)} />
          </ActionIcon>
        );
      },
    },
  ];
};

export default useAccountColumns;
